<template>
	<div class="card">
		<div class="card-header" v-html="Translate('@_NOTIFICATIONS')"></div>
		<div class="card-body" v-if="result !== null">
			<div class="text-left font-weight-bold mb-5">
				<h3 v-if="result.notification.text =='undefined'" v-html="Translate(result.notification.title).replaceArray(result.notification.find || [], result.notification.replace || [])"></h3>
				<h3 v-if="result.notification.text !='undefined'" v-html="Translate(JSON.parse(result.notification).title).replaceArray(result.notification.find || [], result.notification.replace || [])"></h3>
				<span v-html="Translate('@_THESIS')"></span>: <span v-html="result.thesis_title"></span>
				<br />
				<span v-html="Translate('@_UI_NOTIFICATION_SENDER_NAME')"></span>: <span v-html="result.sender_name +' ('+Translate('@_USER_TYPE_' + result.sender_kind)+')'"></span>
				<br />
				<!-- <span v-html="Translate('@_UI_NOTIFICATION_SENDER_EMAIL')"></span>: <span v-html="result.sender_email"></span>
				<br /> -->
				<span v-html="Translate('@_UI_NOTIFICATION_CREATED_DATE')"></span>: <span v-html="result.created_at"></span>
			</div>
			<div class="text-justify" v-if="result.notification.text =='undefined'" v-html="Translate(result.notification.text).replaceArray(result.notification.find || [], result.notification.replace || [])"></div>
			<div class="text-justify" v-if="result.notification.text !='undefined'" v-html="Translate(JSON.parse(result.notification).text).replaceArray(result.notification.find || [], result.notification.replace || [])"></div>
		</div>
		<div class="card-footer" v-if="result !== null">
			<button type="button" class="btn btn-danger ml-1 mr-1" v-html="Translate('@_DELETE')" v-on:click.prevent="deleteData(id)"></button>
			<button type="button" class="btn btn-info ml-1 mr-1" v-html="Translate('@_BACK')" v-on:click.prevent="goBack()"></button>
		</div>
	</div>
</template>

<script>
import Mixin from "@/helpers/mixin";

export default {
	name: "Notification",
	props: {
		id: {
			type: Number,
			default: null
		}
	},
	mixins: [Mixin],
	data() {
		return {
			alert: {
				type: "",
				text: ""
			},
			result: null
		};
	},
	methods: {
		goBack() {
			this.$router.go(-1);
		},
		deleteData(InId) {
			// var r = confirm(this.Translate("@_ARE_YOU_SURE"));
			// if (r !== true) {
			// 	return;
			// }
			this.$store
				.dispatch("http_delete_notification", {
					id: parseInt(InId)
				})
				.then(() => {
					this.ShowAlert("alert-success", this.Translate("@_NOTIFICATION_DELETED"), 5000);
					setTimeout(() => {
						this.goBack();
					}, 2000);
				})
				.catch(e => {
					this.ShowAlert("alert-danger", this.Translate("@_GENERAL_ERROR"), 5000);
					console.error(e);
				});
		},
		getData(InId) {
			this.$store
				.dispatch("http_get_notification", {
					id: parseInt(InId)
				})
				.then(resp => {
					this.result = resp;
				})
				.catch(e => {
					console.error(e);
				});
		}
	},
	created() {
		if (this.id !== null) {
			this.getData(this.id);
		}
	}
};
</script>

<style scoped></style>
